import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidMultisyllabicKeyboardDirectRuleApplication } from '../../../../mechanics/rid-multisyllabic-keyboard-direct-rule-application/rid-multisyllabic-keyboard-direct-rule-application';

@Component({
  selector: 'app-syllabic-keyboard-plus-direct-rule-application-page',
  imports: [RidMultisyllabicKeyboardDirectRuleApplication],
  templateUrl: './syllabic-keyboard-plus-direct-rule-application-page.html',
})
export class SyllabicKeyboardPlusDirectRuleApplicationPage {
  protected readonly $router = inject(Router);
}
